import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import ActionsDropdown from './actions-dropdown.view';
import { connect } from 'react-redux';
import { selectEmployerTimeZone } from 'apps/employer-experience/pages/EmployerDetails/selectors';

const mapStateToProps = state => ({
  employerTz: selectEmployerTimeZone(state),
});

export default compose(connect(mapStateToProps), injectIntl)(ActionsDropdown);
